export default class StickyBottomUntilElement {
    constructor(element) {
        this.$element  = $(element);
        this.$to       = $(this.$element.attr('data-sticky-bottom-until-element'));
        this.$window   = $(window);
        this.lastScrollTop = 0;
    }
    scroll() {
        if (this.$to.length === 0) {
            return;
        }
        const delta = this.$window.height()-(this.$to.offset().top - this.$window.scrollTop()); //position of element relative to window
        const heightfrombottom = this.$to.height()+this.$element.height()+30;
        const st = this.$window.scrollTop();
        if (st >= this.lastScrollTop+4) { //going down
            if(delta >= heightfrombottom){
                this.$element.fadeOut(1000);
            }
            else {
                this.$element.fadeIn(1000);
            }
        }
        else if (st <= this.lastScrollTop-4) {
                if(st+ this.$window.height()-30 <=  this.$to.offset().top+ heightfrombottom+40){
                    this.$element.fadeIn(1000);
            }
        }
        this.lastScrollTop = st;
    }

    setListeners() {
        this.$window.off('scroll.stickyBottomUntilElement').on('scroll.stickyBottomUntilElement', this.scroll.bind(this));
    }

    init() {
        this.setListeners();
    }
}
